import React from "react";
import { Typography, Box } from "@mui/material";
import { useUserContext } from "../context/UserContext";

const TenantBanner = () => {
  const { userRole, selectedTenantName } = useUserContext();

  if (userRole !== "SuperAdmin" || !selectedTenantName) return null;

  return (
    <Box sx={{ 
      mt: 0, 
      mb: 2, 
      pt: 1,
      px: 4,
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center'
    }}>
      <Box sx={{
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: '8px 16px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
      }}>
        <Typography 
          variant="subtitle1" 
          sx={{
            color: 'black',
            fontSize: '0.9rem',
            fontWeight: 500
          }}
        >
          Your Organization: <b style={{ color: 'black' }}>{selectedTenantName}</b>
        </Typography>
      </Box>
    </Box>
  );
};

export default TenantBanner;